/**
 * Post status colors
 * These colors match the badge colors used in PostListItem component
 */
export const POST_STATUS_COLORS: Record<string, string> = {
  PENDING: '#3B82F6', // blue-500
  EXECUTING: '#F59E0B', // amber-500
  COMPLETED: '#10B981', // green-500
  FAILED: '#EF4444', // red-500
  CANCELLED: '#6B7280' // gray-500
};

/**
 * User status colors
 */
export const USER_STATUS_COLORS: Record<string, string> = {
  ACTIVE: '#10B981', // green-500
  RESTRICTED: '#F59E0B', // amber-500
  SUSPENDED: '#EF4444', // red-500
  BLOCKED: '#DC2626' // red-600
};

/**
 * Get color for post status
 */
export function getPostStatusColor(status: string): string {
  return POST_STATUS_COLORS[status] ?? '#6B7280'; // Default to gray-500
}

/**
 * Get color for user status
 */
export function getUserStatusColor(status: string): string {
  return USER_STATUS_COLORS[status] ?? '#6B7280'; // Default to gray-500
}

/**
 * Status badge Tailwind classes.
 * Shared between PostListItem and ReservedActionListItem so both post rows
 * and reserved action rows (POST / REPOST / DELETE_POST) render identical
 * status badges.
 */
export const STATUS_BADGE_CLASSES: Record<string, string> = {
  PENDING: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
  EXECUTING: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300',
  COMPLETED: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
  FAILED: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
  CANCELLED: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300'
};

/**
 * Get Tailwind classes for a status badge
 */
export function getStatusBadgeClass(status: string): string {
  return (
    STATUS_BADGE_CLASSES[status] ?? 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300'
  );
}

/**
 * Reserved action kind colors (for charts: pie / stacked column)
 */
export const RESERVED_ACTION_KIND_COLORS: Record<string, string> = {
  POST: '#3B82F6', // blue-500
  REPOST: '#8B5CF6', // violet-500
  DELETE_POST: '#F59E0B' // amber-500
};

/**
 * Reserved action kind display labels (English, matches existing admin panel tone)
 */
export const RESERVED_ACTION_KIND_LABELS: Record<string, string> = {
  POST: 'Post',
  REPOST: 'Repost',
  DELETE_POST: 'Delete'
};

/**
 * Get color for a reserved action kind
 */
export function getReservedActionKindColor(kind: string): string {
  return RESERVED_ACTION_KIND_COLORS[kind] ?? '#6B7280'; // Default to gray-500
}
